import { Container, Sprite } from 'pixi.js';
import DisplayObject = PIXI.DisplayObject;

export default class MapBackground extends Container {
    public backgroundHeight: number = 0;
    public backgroundWidth: number = 0;
    private container: Container;

    constructor() {
        super();
        const c = new Container();
        this.addChild(c);
        const pieces: DisplayObject[] = [];
        let i = 0;

        while (i < 10) {
            const tex = PIXI.utils.TextureCache['worldmap-' + (i + 1).toString()];
            const piece = new Sprite(tex);
            // piece.cacheAsBitmap = true;
            piece.y = (piece.height - 2) * pieces.length;
            pieces.push(piece);
            c.addChild(piece);

            if (!this.backgroundHeight) {
                this.backgroundHeight = piece.height * 10;
                this.backgroundWidth = piece.width;
            }

            i++;
        }

        c.addChild(pieces.shift(), ...pieces);
        this.container = c;
    }

    public cleanUp() {
        // const wrapper = this.getChildAt(0);
        const pieces = this.container.children;
        pieces.forEach(pieceWrapper => {
            const piece = pieceWrapper as Sprite;
            // piece.cacheAsBitmap = false;
            piece.destroy();
        });

        this.container.destroy();
        this.destroy();
    }
}
